import React, { Component } from "react";
import { Alert } from "react-bootstrap";

import Onboard from "../../blocks";
import AddressForm from "./AddressForm";
import { RemoteSubmitButton } from "../../NextButton";
import { getActionIsRequired, getCustomErrorMsg } from "../../utils";
import { compose, connect, mutateAsync } from "queries/utils";
import { updateOwnContractorQuery } from "queries/mutations/contractors";
import { handleSubmitError, redirectToNextStepIfNeeded } from "../../utils";
import { validateRequiredFields } from "common/utils/forms";
import DesktopOnly from "common/blocks/DesktopOnly";
import MobileOnly from "common/blocks/MobileOnly";
import Label from "common/blocks/Label";

const stepName = "address";
const requiredFields = ["address_1", "city", "state", "postal_code"];

class Address extends Component {
  constructor(props) {
    super(props);
    this.state = { nextButtonLoading: false };
  }

  handleSubmitAddressForm = async values => {
    await this.setState({ nextButtonLoading: true });

    const {
      props: {
        ownContractor: { uuid },
        updateOwnContractor,
      },
      handleNextClick,
      stopButtonLoading,
    } = this;
    const result = await updateOwnContractor({ location: values }, uuid);

    stopButtonLoading();
    handleSubmitError(result);
    handleNextClick();
  };

  validate = values => validateRequiredFields(requiredFields, values);

  handleNextClick = () => {
    redirectToNextStepIfNeeded(
      stepName,
      this.props.refreshReqs,
      this.stopButtonLoading,
    );
  };

  stopButtonLoading = () => this.setState({ nextButtonLoading: false });

  render() {
    const {
      state: { nextButtonLoading },
      props: {
        ownContractor,
        reqs: { steps },
      },
      handleSubmitAddressForm,
      validate,
    } = this;
    const actionIsRequired = getActionIsRequired(stepName, steps);
    const customErrorMsg = getCustomErrorMsg(stepName, steps);
    const location = ownContractor.location;

    return (
      <Onboard.Page>
        <Onboard.Container>
          <DesktopOnly>
            <Onboard.ContainerHeader>
              <div>
                <h1>Address</h1>
              </div>
              <div>
                {actionIsRequired && (
                  <Label color="danger">ACTION REQUIRED</Label>
                )}
              </div>
            </Onboard.ContainerHeader>
          </DesktopOnly>
          <MobileOnly>
            <h1>Address</h1>
            {actionIsRequired && (
              <div>
                <Label color="danger">ACTION REQUIRED</Label>
                <br />
                <br />
              </div>
            )}
          </MobileOnly>
          {customErrorMsg && <Alert bsStyle="danger">{customErrorMsg}</Alert>}
          <AddressForm
            initialValues={location}
            onSubmit={handleSubmitAddressForm}
            validate={validate}
          />
        </Onboard.Container>
        <RemoteSubmitButton
          formName="onboardingAddressForm"
          isLoading={nextButtonLoading}
        />
      </Onboard.Page>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  updateOwnContractor: (data, uuid) =>
    dispatch(mutateAsync(updateOwnContractorQuery(data, uuid))),
});

export default compose(
  connect(
    null,
    mapDispatchToProps,
  ),
)(Address);
